import { Icon } from "@wisr/react-ui";
import { navigate } from "gatsby";
import React from "react";

import { getPathFromLocation } from "../../../shared/gatsby.utils";
import { GatsbyPageLocation } from "../../../types/gatsby";
import layoutStyle from "../application-layout.scss";
export const MultiPageFormProgress = ({
  location,
}: {
  location: GatsbyPageLocation | undefined;
}) => {
  const pathname = getPathFromLocation(location);
  const isHidden = pathname === "quote" || pathname === "application";

  return (
    <div className="multi-page-form-progress">
      <style jsx>{layoutStyle}</style>
      <div className="back-button-wrapper">
        <div
          className={`back-button ${isHidden ? "fake" : ""}`}
          onClick={() => navigate(-1)}
        >
          <Icon name="navigation-arrow-left" size="sm" legacy={true} />
          <span>Back</span>
        </div>

        <div className={`progress-bar ${pathname}`}>
          <div className={`inner-progress ${pathname}`} />
        </div>
        <div className="back-button fake" style={{ width: "60px" }}></div>
      </div>
    </div>
  );
};
